import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

const INITIAL_SHOW_DELAY = 5000;      // ms (5sec) — wait before showing popup on page load
const REAPPEAR_AFTER_DISMISS = 180000; // ms (3 min) — reappear after user closes it
const ROTATE_INTERVAL = 15000;         // ms — swap to next offer automatically while visible
const TRANSITION_PAUSE = 400;          // ms — brief hide while swapping offer

interface Offer {
  title: string;
  description: string;
  image: string;
  page_link: string;
  button:string;
}

// ── Static offer data — edit this JSON block directly ───────────
const OFFERS_DATA: Offer[] = [

  {
    title: 'Free 11+ CSSE Predictor',
    description: 'Free CSSE Prediction to Predict your spot in Grammar School',
    image: 'assets/images/free-predictor.png',
    page_link: '/free-csse-predictor',
    button: 'Check Now'
  },

   {
    title: 'Admission Open',
    description: 'KS1 • KS2 • 7+ • 11+ • 12+ • 13+ • KS3 • ISEB • GCSE • A-Level',
    image: 'assets/images/admisson-open.jpg',
    page_link: 'https://forms.zohopublic.in/sehyogacademy1/form/REGISTRATIONFORMADMISSIONOPEN2026/formperma/hpOlMpe-JndfteUZQyBtjLV9tJWlnKMVZddMgqhC9Hk?fbclid=IwdGRjcAT9U2NjbGNrBP1TX3Bkb2YFZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMzUwNjg1NTMxNzI4AAEesicW7z4b22u1noxXBm-NZUJ2advQ7hbAwfFM-A1k4IQDIgT7UXFlAYAhODc_aem_TpVixDyiLiFh459nai90aw',
    button: 'Enroll Now'
  },

  // {
  //   title: 'Expert Webinars 11+ & GCSE Mastery',
  //   description: 'CSSE  |  FSCE  |  GL  |  SET  |  ISEB  |  AQA  |  OCR  |  EDEXCEL  |  EDUQAS  |  A LEVEL ',
  //   image: 'assets/images/free-webinar.jpg',
  //   page_link: 'https://zfrmz.in/rsyoypG8JC7NYwLd1Plz',
  //   button: 'Register Now'
  // },
  
];

@Component({
  selector: 'app-offer-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.css']
})
export class OfferBannerComponent implements OnInit, OnDestroy {
  offer: Offer | null = null;
  visible = false;

  private currentIndex = 0;
  private showTimer: any = null;
  private reappearTimer: any = null;
  private rotateTimer: any = null;

  ngOnInit() {
    if (OFFERS_DATA.length) {
      this.currentIndex = 0;
      this.offer = OFFERS_DATA[this.currentIndex];

      this.showTimer = setTimeout(() => {
        this.visible = true;
        this.scheduleRotate();
      }, INITIAL_SHOW_DELAY);
    }
  }

  // ── Auto-rotate between offers while visible ────────────────────
  private scheduleRotate() {
    this.clearRotateTimer();
    if (OFFERS_DATA.length <= 1) { return; }
    this.rotateTimer = setTimeout(() => { this.rotateOffer(); }, ROTATE_INTERVAL);
  }

  private rotateOffer() {
    this.visible = false;
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % OFFERS_DATA.length;
      this.offer = OFFERS_DATA[this.currentIndex];
      this.visible = true;
      this.scheduleRotate();
    }, TRANSITION_PAUSE);
  }

  // ── User dismisses — reappears after 3 minutes with next offer ──
  dismiss() {
    this.clearRotateTimer();
    this.visible = false;
    this.reappearTimer = setTimeout(() => {
      if (OFFERS_DATA.length > 1) {
        this.currentIndex = (this.currentIndex + 1) % OFFERS_DATA.length;
        this.offer = OFFERS_DATA[this.currentIndex];
      }
      this.visible = true;
      this.scheduleRotate();
    }, REAPPEAR_AFTER_DISMISS);
  }

  // ── Click → navigate ─────────────────────────────────────────
  onBannerClick() {
    if (!this.offer) { return; }
    const link = this.offer.page_link;
    if (!link) { return; }
    if (link.indexOf('/') === 0) {
      window.location.href = link;
    } else {
      window.open(link, '_blank');
    }
  }

  imageSrc(): string {
    if (this.offer && this.offer.image) { return this.offer.image; }
    return 'assets/images/default-offer.png';
  }

  private clearRotateTimer() {
    if (this.rotateTimer) { clearTimeout(this.rotateTimer); this.rotateTimer = null; }
  }

  ngOnDestroy() {
    if (this.showTimer) { clearTimeout(this.showTimer); }
    if (this.reappearTimer) { clearTimeout(this.reappearTimer); }
    this.clearRotateTimer();
  }
}